import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import SideBar from '../SideBar/index.js';
import SideBarHeader from '../SideBarHeader/index.js';
import Modal from '../Modal/index.js';
import ModalBody from '../ModalBody/index.js';
import ModalFooter from '../ModalFooter/index.js';
import ModalHeader from '../ModalHeader/index.js';
import ModalTitle from '../ModalTitle/index.js';
import ModalScrollPanel from '../ModalScrollPanel/index.js';

/**
 *  The SideBarToModal component switches between a SideBar and a Modal
 *
 */
function SideBarToModal(_ref) {
  let {
    title = '',
    container,
    // For Syndicated Calc
    content,
    collapsed = true,
    show = false,
    onHide = () => {},
    sideBarOptions,
    modalOptions,
    ...rest
  } = _ref;
  const renderSideBar = () => {
    const sideBarHeader = /*#__PURE__*/_jsx(SideBarHeader, {
      title: title,
      onHide: onHide,
      action: sideBarOptions.action
    });
    delete sideBarOptions.action;
    return /*#__PURE__*/React.createElement(SideBar, Object.assign({
      show: show,
      onHide: onHide,
      header: sideBarHeader
    }, sideBarOptions), /*#__PURE__*/_jsx("div", {
      className: "padding-horizontal-3"
    }, void 0, content.sideBar ? content.sideBar : content));
  };
  const getModalBody = () => {
    const modalContent = content.modal ? content.modal : content;
    const contentWithScrollPanel = /*#__PURE__*/_jsx(ModalScrollPanel, {}, void 0, modalContent);
    return modalOptions.scrollPanel ? contentWithScrollPanel : modalContent;
  };
  const {
    footerContent
  } = rest;
  delete rest.footerContent;
  const renderModal = /*#__PURE__*/_jsx(Modal, {
    bsStyle: modalOptions.bsStyle,
    bsSize: modalOptions.bsSize,
    show: show,
    onHide: onHide,
    container: container
  }, void 0, /*#__PURE__*/_jsx(ModalHeader, {
    closeButton: true
  }, void 0, /*#__PURE__*/_jsx(ModalTitle, {}, void 0, title)), /*#__PURE__*/_jsx(ModalBody, {}, void 0, getModalBody()), footerContent && /*#__PURE__*/_jsx(ModalFooter, {}, void 0, footerContent));
  return show && /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "sideBarToModal"
  }, rest), collapsed && !container ? renderSideBar() : renderModal);
}
export default SideBarToModal;